import { render, staticRenderFns } from "./poa_actividades_linea_accion.vue?vue&type=template&id=063efad6&"
import script from "./poa_actividades_linea_accion.vue?vue&type=script&lang=ts&"
export * from "./poa_actividades_linea_accion.vue?vue&type=script&lang=ts&"
import style0 from "./poa_actividades_linea_accion.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports